import { Pagination } from "@mui/material"

const PaginationItem = ({
  actualDocs,
  totalDocs,
  entity,
  totalPages,
  actualPage,
  handlePageChange,
  variant = "vertical",
  siblingCount = 1,
  boundaryCount = 1,
}) => {
  return (
    <div className={variant === "vertical" ? "w-full flex flex-col gap-2 py-3 justify-center items-center" : "w-full flex flex-row gap-2 py-3 justify-center items-center"}>
      <span className="text-xs text-gray-700 dark:text-gray-500">
        Mostrando
        <span className="font-semibold text-gray-900 dark:text-gray-300">
          {" "}
          {actualDocs}
        </span>{" "}
        de
        <span className="font-semibold text-gray-900 dark:text-gray-300">
          {" "}
          {totalDocs}
        </span>{" "}
        {entity}
      </span>
      <Pagination
        count={totalPages}
        page={actualPage}
        variant="outlined"
        shape="rounded"
        size="small"
        onChange={handlePageChange}
        siblingCount={siblingCount}
        boundaryCount={boundaryCount}
      />
    </div>
  )
}

export default PaginationItem